import { Loader, Stack, Text } from '@mantine/core';
import { Navigate, Outlet, useLocation } from 'react-router';
import { CenteredScreen } from '@/components/centered-screen';
import { LogoMark } from '@/components/logo';
import { useAuth } from './auth-context';

/**
 * Route guard for everything behind the login.
 *
 * This controls what the UI renders, not what the user can access. The bundle
 * is public and every API request is authorised independently — see the
 * security note in the README.
 */
export function RequireAuth() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <CenteredScreen>
        <Stack align="center" gap="md">
          <LogoMark size={44} />
          <Loader size="sm" />
          <Text size="sm" c="dimmed">
            Checking your session…
          </Text>
        </Stack>
      </CenteredScreen>
    );
  }

  if (!user) {
    // Remember where they were headed so sign-in can return them there.
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
